<template>
  <div class="page-header">
    <!-- Left side: Hamburger + Mobile Logo -->
    <div class="header-left">
      <HamburgerButton />
      <div class="mobile-logo">
        <div class="logo-icon">$</div>
        <span class="logo-text">FinanceHub</span>
      </div>
    </div>

    <!-- Right side: FY Dropdown -->
    <div class="header-dropdown">
      <button class="dropdown-button" @click="toggleDropdown">
        <span class="calendar-icon">&#x1F4C5;</span>
        <span class="fy-text">{{ selectedFY || 'Select Year' }}</span>
        <span class="chevron-icon">&#x25BC;</span>
      </button>

      <div v-if="isDropdownOpen" class="dropdown-menu">
        <div
          class="dropdown-item"
          v-for="year in accountingYears"
          :key="year.id"
          @click="selectFY(year)"
        >
          <span>{{ year.name }}</span>
          <span v-if="year.isActive" class="current-badge">Current</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HamburgerButton from '@/components/layout/HamburgerButton.vue'

export default {
  name: 'PageHeader',

  components: {
    HamburgerButton
  },

  data() {
    return {
      selectedFY: null,
      isDropdownOpen: false
    }
  },

  computed: {
    ...mapState('accounting', ['years']),

    accountingYears() {
      if (!Array.isArray(this.years)) return []
      return this.years
    }
  },

  watch: {
    years: {
      immediate: true,
      handler(years) {
        const activeYear = years.find(y => y.isActive === true)
        if (activeYear) {
          this.selectedFY = activeYear.name
        }
      }
    }
  },

  methods: {
    ...mapActions('accounting', ['SetActiveYear']),

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },

    async selectFY(year) {
      if (year.isActive) {
        this.isDropdownOpen = false
        return
      }
      this.selectedFY = year.name
      this.isDropdownOpen = false
      await this.SetActiveYear(year.id)
    }
  },

  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.isDropdownOpen = false
      }
    })
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Mobile Logo - hidden on desktop */
.mobile-logo {
  display: none;
  align-items: center;
  gap: 8px;
}

.mobile-logo .logo-icon {
  width: 32px;
  height: 32px;
  background: #2563eb;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: white;
}

.mobile-logo .logo-text {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
}

.header-dropdown {
  position: relative;
}

.dropdown-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  transition: all 0.2s ease;
}

.dropdown-button:hover {
  border-color: #2563eb;
  background: #f0f4f8;
}

.calendar-icon {
  font-size: 16px;
}

.fy-text {
  min-width: 100px;
}

.chevron-icon {
  font-size: 12px;
  color: #6b7280;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  color: #1f2937;
  font-size: 14px;
  transition: background 0.2s ease;
}

.dropdown-item:hover {
  background: #f3f4f6;
}

.dropdown-item:first-child {
  border-radius: 8px 8px 0 0;
}

.dropdown-item:last-child {
  border-radius: 0 0 8px 8px;
}

.current-badge {
  background: #2563eb;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 1024px) {
  .page-header {
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 12px 16px;
  }

  .mobile-logo {
    display: flex;
  }
}

@media (max-width: 480px) {
  .dropdown-button {
    padding: 8px 12px;
  }

  .fy-text {
    min-width: auto;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .calendar-icon {
    display: none;
  }
}
</style>
